import ReactDOM from "react-dom/client";
import "styles/index.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isToday from "dayjs/plugin/isToday";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import App from "app/App";
import i18n from "common/i18n";
import { insideInstalledApp } from "common/utils";

dayjs.extend(utc);
dayjs.extend(isToday);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

i18n.locale = "ja";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    deferredPrompt?: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ReactNativeWebView?: any;
    kidsAppHostRegionCode?: string;
    kidsAppHostLanguageCode?: string;
    kidsAppPlatform?: string;
    kidsAppVersion?: string;
    kidsBuildVersion?: string;
  }
}

if (insideInstalledApp()) {
  window.resizeBy(1024 - window.innerWidth, 768 - window.innerHeight);
}
